import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Infrastructure from './components/Infrastructure';
import CourseModules from './components/CourseModules'; // NOVO
import Internships from './components/Internships'; // NOVO
import ProfessionalProfile from './components/ProfessionalProfile'; // NOVO
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="font-sans text-slate-800 bg-gray-50">
      <Navbar />
      <Hero />
      <Features />        {/* Fundo Cinza Claro */}
      <CourseModules />   {/* Fundo Branco */}
      <Internships />     {/* Fundo Navy (Escuro) */}
      <ProfessionalProfile /> {/* Fundo Branco / Card Cinza */}
      <Infrastructure />  {/* Fundo Navy Escuro */}
      <FAQ />             {/* Fundo Cinza Claro */}
      <Footer />
    </div>
  );
}

export default App;